/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ApplicationRef, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injectable, Injector, inject } from '@angular/core';

@Injectable()
export class DisplayNotificationUiPanelService {
  private factoryResolver = inject(ComponentFactoryResolver);
  private appRef = inject(ApplicationRef);
  private injector = inject(Injector);


  componentRef: ComponentRef<unknown> | undefined = undefined;

  firstClick = true;

  reset(): void {
    if(!this.componentRef) {
      return;
    }

    this.appRef.detachView(this.componentRef.hostView);
    this.notificationPanelClicked();
    this.componentRef.destroy();
  }

  insertSadComponent(component: any): void {
    this.insertComponent(component);
  }

  private insertComponent(componentType: any): void {
    this.componentRef = this.factoryResolver.resolveComponentFactory(componentType).create(this.injector);
    this.appRef.attachView(this.componentRef?.hostView);

    const domElem = (this.componentRef?.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    document.body.appendChild(domElem);
    this.notificationPanelReset();
  }

  notificationPanelClicked() {
    this.firstClick = true;
  }

  notificationPanelReset() {
    this.firstClick = false;
  }

  getNotificationPanelClickState() {
    return this.firstClick;
  }
}
